<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >

    <div class="pl-60 pr-60 pt-20">

      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form1" :rules="loginRules1">
        <a-form-model-item prop="department" label="所属部门">
          <a-select
            v-model="form1.department"
            show-search
            placeholder="请选择部门"
            class="w-100p"
          >
            <a-select-option v-for="i in departmentList" :key="i.departmentid" :value="JSON.stringify(i)">
              {{ i.departmentname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="positiontype" label="职位">
          <a-select
            v-model="form1.positiontype"
            placeholder="请选择部门"
            class="w-100p"
          >
            <a-select-option :value="1">
              普通员工(寄快递)
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="staffname" label="员工昵称">
          <a-input v-model="form1.staffname" :maxLength="20" placeholder="请填写员工昵称" />
        </a-form-model-item>
        <a-form-model-item prop="username" label="登录账号">
          <a-input v-model="form1.username" :maxLength="20" placeholder="建议使用手机号或员工邮箱" />
        </a-form-model-item>
        <a-row class="f-c-red">
          <a-col :offset="4">提示：初始密码为：888666，请在登录后尽快修改。</a-col>
        </a-row>
        <a-row class="mt-20 mb-20">
          <a-col :offset="4">  <a-button
            type="primary"
            :loading="formLoading"
            @click="postForm1"
          >
            保存
          </a-button></a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-modal>
</template>
<script>
export default {
  components: {
  },
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '新增员工(子账号)',
      st: 1,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      loginRules1: {

        department: [
          { required: true, trigger: 'change' }
        ],
        positiontype: [
          { required: true, trigger: 'change', message: '请选择职位' }
        ],
        staffname: [
          { required: true, trigger: 'change', message: '请填写员工昵称' }
        ],
        username: [
          { required: true, trigger: 'change', message: '请填写用户名' }
        ]

      },
      visible: this.viz,
      confirmLoading: false,
      form1: {
        department: JSON.stringify({
          'departmentid': 0,
          'departmentname': this.$store.state.user.company,
          'parentid': 0
        }),
        'departmentid': 0,
        'parentId': 0,
        'positiontype': 1,
        'staffname': '',
        'username': ''
      },
      formLoading: false,
      departmentList: [
        {
          'departmentid': 0,
          'departmentname': this.$store.state.user.company,
          'parentid': 0
        }

      ]
    }
  },
  watch: {
    visible(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.visible = n
      if (n) {
        this.getList()
      }
    }
  },
  async created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await this.$http(this.$api.departmentGetDepartmentList)
      this.departmentList = [
        {
          'departmentid': 0,
          'departmentname': this.$store.state.user.company,
          'parentid': 0
        }

      ].concat(res)
    },
    onChange() {
    },
    close() {
      this.visible = false
    },
    show() {
      this.visible = true
    },

    postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true

          try {
            const res = await this.$http({ ...this.$api.staffAddStaff, origin: true }, {
              'departmentid': JSON.parse(this.form1.department).departmentid,
              'parentId': JSON.parse(this.form1.department).parentId,
              'positiontype': this.form1.positiontype,
              'staffname': this.form1.staffname,
              'username': this.form1.username
            })
            if (res.data.state === 'success') {
              this.formLoading = false
              this.$success({
                title: '提示',
                type: 'success',
                content: '添加员工成功',
                onOk: () => {
                  this.visible = false
                  this.$emit('ok')
                }
              })
            } else {
              this.$message.error(res.data.msg || '未知错误')
              this.formLoading = false
            }
          } catch (error) {
            this.formLoading = false
          }
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
.pci-table{
  width: 100%;
  text-align: center;
  // border-color: #dedede;;
  th{
    background: #dedede;
  }
  .bg-red{
    background: #ff4747;
  }
  th,td{
    width: 33.33%;
  }
}
</style>
